import { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../api';

const VACIO = { nombre: '', ruc: '', direccion: '', telefono: '', email: '' };

export default function ProveedorForm({ proveedor, onGuardado, onCancelar }) {
  const [form, setForm] = useState(
    proveedor
      ? { nombre: proveedor.nombre, ruc: proveedor.ruc, direccion: proveedor.direccion, telefono: proveedor.telefono, email: proveedor.email }
      : VACIO
  );
  const [guardando, setGuardando] = useState(false);

  function set(campo) {
    return (e) => setForm((f) => ({ ...f, [campo]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.nombre.trim()) {
      toast.error('El nombre es obligatorio.');
      return;
    }
    setGuardando(true);
    try {
      const res = proveedor
        ? await api.patch(`/proveedores/${proveedor.id}/`, form)
        : await api.post('/proveedores/', form);
      toast.success(proveedor ? 'Proveedor actualizado.' : 'Proveedor agregado.');
      onGuardado(res.data);
    } catch (err) {
      const detalle = err.response?.data;
      const mensaje = detalle ? Object.values(detalle).flat().join(' ') : 'No se pudo guardar el proveedor.';
      toast.error(mensaje);
    } finally {
      setGuardando(false);
    }
  }

  return (
    <form className="nuevo-banco" onSubmit={handleSubmit}>
      <label>Nombre o Razón Social</label>
      <input value={form.nombre} onChange={set('nombre')} placeholder="Ej. Comercial Andina S.A." required />

      <div className="coord-inputs">
        <div>
          <label>RUC</label>
          <input value={form.ruc} onChange={set('ruc')} maxLength={13} />
        </div>
        <div>
          <label>Teléfono</label>
          <input value={form.telefono} onChange={set('telefono')} />
        </div>
      </div>

      <label>Dirección</label>
      <input value={form.direccion} onChange={set('direccion')} />

      <label>Email</label>
      <input type="email" value={form.email} onChange={set('email')} />

      <div className="acciones-nuevo-banco">
        <button type="button" className="btn-secundario" onClick={onCancelar}>Cancelar</button>
        <button type="submit" className="btn-primary" disabled={guardando}>
          {guardando ? 'Guardando…' : 'Guardar proveedor'}
        </button>
      </div>
    </form>
  );
}
